var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-manage-tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-remove": _vm.removeTab },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "消费订单", name: "dish", closable: false } },
            [
              _c("orderList", {
                attrs: { userId: _vm.userId, abnormalFlag: 0 },
                on: {
                  "open-edit": _vm.handleOpenEdit,
                  "open-add": _vm.handleOpenAdd,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "异常订单", name: "abnormal", closable: false } },
            [
              _c("orderList", {
                attrs: { userId: _vm.userId, abnormalFlag: 1 },
                on: {
                  "open-edit": _vm.handleOpenEdit,
                  "open-add": _vm.handleOpenAdd,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.editTabs, function (item) {
            return _c(
              "el-tab-pane",
              {
                key: item.name,
                attrs: { label: item.title, name: item.name, closable: true },
              },
              [
                _c("orderDetail", {
                  attrs: { orderId: item.orderId, type: item.type },
                  on: {
                    saved: function ($event) {
                      return _vm.closeEditTab(item.name, true)
                    },
                    cancel: function ($event) {
                      return _vm.closeEditTab(item.name, false)
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }